import getConfig from '../../../config';
import useReturnPath from '../../../common/hooks/use-return-path';

function RedirectToSso() {
  const { ssoUrl } = getConfig();
  const [, setReturnPath] = useReturnPath();

  setReturnPath(window.location.pathname);

  window.location.href = new URL(ssoUrl).href;
  return null;
}

export default RedirectToSso;
